var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-with-stars"},[(_vm.src)?_c('img',{staticClass:"avatar-with-stars__img",attrs:{"src":_vm.src,"alt":"avatar"}}):_c('div',{staticClass:"avatar-with-stars__img"})])
}
var staticRenderFns = []

export { render, staticRenderFns }